import type {ConnectElementConfig} from '../../../connect/ConnectJSInterface/ConnectElementList';

const SIMPLIFIED_UI_CONFIG_HTML_ATTRIBUTE = 'simplified' as const;
const FROM_INTERNAL_SITE_HTML_ATTRIBUTE = 'from-internal-site' as const;
const EXPRESS_BRANDING_SETTINGS_HTML_ATTRIBUTE =
  'express-branding-settings' as const;

export const DebugUIConfig: ConnectElementConfig = {
  Component: () =>
    import(
      /* webpackChunkName: "debugUIConfig" */ '../../../components/Debug/UIConfig/UIConfig'
    ),
  enabledKey: 'internal',
  releaseState: 'internal',
  ignoreThemingValues: true,
  sentryTeam: 'accounts_ui',
  teamOwner: 'connected-account-experiences-eng',
  htmlAttributes: {
    // Internal - to enable these for platforms, we'll need API review
    [SIMPLIFIED_UI_CONFIG_HTML_ATTRIBUTE]: {
      isInternal: true,
    },
    [FROM_INTERNAL_SITE_HTML_ATTRIBUTE]: {
      isInternal: true,
    },
    [EXPRESS_BRANDING_SETTINGS_HTML_ATTRIBUTE]: {
      isInternal: true,
    },
  },
  customHtmlElementMethods: {
    setExpressBrandingSettings: {
      type: 'AttributeSettingMethod',
      attribute: EXPRESS_BRANDING_SETTINGS_HTML_ATTRIBUTE,
      isInternal: true,
      description:
        'When `true`, this means the component is being rendered in the standard dashboard in the Express branding drawer.',
    },
  },
  description:
    'Allows for configuring theming in Connect embedded components. Used in the Stripe doc site for the theming demo, and for theming the Express dashboard from the Stripe Dashboard.',
  friendlyName: 'Debug UI config',
};
